import styled from 'styled-components';
import { media, mixins } from '../../../css';

export const StyledFooterColumn = styled.div`
  padding-bottom: ${mixins.pxToRem(60)};
  ${media.greaterThan('md')`
    padding-bottom: ${mixins.pxToRem(25)};
  `};
`;
